
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604297151278",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1266",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "74",
    "height": "74"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M704 102.4h-307.2c-53.76 0-102.4 48.64-102.4 102.4h-30.72c-53.76 0-97.28 48.64-97.28 102.4v512c0 53.76 48.64 102.4 102.4 102.4h384c53.76 0 102.4-48.64 102.4-102.4h25.6c53.76 0 102.4-48.64 102.4-102.4V307.2l-179.2-204.8z m-51.2 768h-384c-25.6 0-51.2-25.6-51.2-51.2V307.2c0-25.6 23.04-51.2 48.64-51.2h28.16v460.8c0 53.76 48.64 102.4 102.4 102.4h307.2c0 25.6-25.6 51.2-51.2 51.2z m179.2-153.6c0 25.6-25.6 51.2-51.2 51.2h-384c-25.6 0-51.2-25.6-51.2-51.2V204.8c0-25.6 25.6-51.2 51.2-51.2h256v102.4c0 53.76 48.64 102.4 102.4 102.4h76.8v358.4z m-76.8-409.6c-28.16 0-51.2-48.64-51.2-76.8V153.6l128 153.6h-76.8z m-51.2 153.6h-230.4c-15.36 0-25.6 10.24-25.6 25.6s10.24 25.6 25.6 25.6h230.4c15.36 0 25.6-10.24 25.6-25.6 0-12.8-10.24-25.6-25.6-25.6z m0 128h-230.4c-15.36 0-25.6 10.24-25.6 25.6s10.24 25.6 25.6 25.6h230.4c15.36 0 25.6-10.24 25.6-25.6 0-12.8-10.24-25.6-25.6-25.6z",
        "p-id": "1267"
      }
    }
  ]
})
    }
  